const apiRoot = `${process.env.REACT_APP_ENERGY_DASHBOARD_API_URL}/api`;
const url = `${apiRoot}/projects`;

export const trScenarioUrls = {
  config: (projectId: string) => `${url}/${projectId}/tr-config`,
  configDetail: (projectId: string, configId: number) =>
    `${apiRoot}/tr-config/${configId}?project_id=${encodeURIComponent(projectId)}`,
  detail: (projectId: string, scenarioId: number) => `${url}/${projectId}/tr-scenarios/${scenarioId}`,
  list: (projectId: string) => `${url}/${projectId}/tr-scenarios`,
};
